export default __webpack_public_path__ + "static/media/hero.579f3333.png";